import { store } from '@/store';
import ExtraData from '@/models/ExtraData';
import QuestionBuilder from './QuestionBuilder';

export default class ColourQuestionBuilder extends QuestionBuilder {
    public constructor() {
        super(false, true);
    }

    answers() {
        const colours = Object.keys(store.getters['vehicleSearchModule/colours']);
        colours.push('Not sure');
        return colours;
    }

    setAnswer(answer: string) {
        if (answer === 'notsure') {
            store.dispatch('enquiryModule/submitRemoveExtraData', 'basicColour');
            const extraData = new ExtraData('basicColourKnown', 'false');
            store.dispatch('enquiryModule/submitExtraData', extraData);
        } else if (answer) {
            const extraData = new ExtraData('basicColour', answer);
            store.dispatch('enquiryModule/submitExtraData', extraData);
            const extraData2 = new ExtraData('basicColourKnown', 'true');
            store.dispatch('enquiryModule/submitExtraData', extraData2);
        } else {
            store.dispatch('enquiryModule/submitRemoveExtraData', 'basicColourKnown');
            store.dispatch('enquiryModule/submitRemoveExtraData', 'basicColour');
        }
    }
}
